import appApi from '../../../../../api/app-api';
import { displayErrorText } from '../../../../../api/errors/api-error-codes';
import { toast } from 'react-toastify';

const extractFilenameFromContentDisposition = (
  contentDisposition: string | undefined,
): string | null => {
  if (!contentDisposition) return null;

  // Examples:
  // attachment; filename="file.txt"
  // attachment; filename*=UTF-8''file.txt
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) return decodeURIComponent(utf8Match[1].replace(/"/g, ''));

  const match = contentDisposition.match(/filename="?([^"]+)"?/i);
  if (match?.[1]) return match[1];

  return null;
};

const downloadBlob = (blob: Blob, filename: string) => {
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

const tryParseGenericError = async (
  blob: Blob,
): Promise<{ errCode?: string } | null> => {
  try {
    const text = await blob.text();
    const parsed = JSON.parse(text);
    if (parsed && typeof parsed === 'object' && 'errCode' in parsed) {
      return parsed as { errCode?: string };
    }
    return null;
  } catch {
    return null;
  }
};

export const generateMasavFileOperation = async (
  selectedMonth: Date | null,
  setLoading: (loading: boolean) => void,
): Promise<boolean> => {
  if (!selectedMonth) {
    toast.warn('יש לבחור חודש לפני הפקת קובץ מס״ב');
    return false;
  }

  const year = selectedMonth.getFullYear();
  const month = selectedMonth.getMonth() + 1; // 1-12

  try {
    setLoading(true);

    const res = await appApi.generateMasavFile({ year, month });
    const blob = res.data;

    const maybeErr = await tryParseGenericError(blob);
    if (maybeErr?.errCode) {
      toast.warn(displayErrorText(maybeErr.errCode));
      setLoading(false);
      return false;
    }

    const filenameFromHeader = extractFilenameFromContentDisposition(
      res.headers?.['content-disposition'],
    );
    //const fallbackFilename = `masav-${year}-${String(month).padStart(2, '0')}.txt`;
    const fallbackFilename = `masav-${year}-${String(month).padStart(2, '0')}.001`;

    downloadBlob(blob, filenameFromHeader || fallbackFilename);
    toast.success('קובץ מס״ב הופק והורד בהצלחה');
    setLoading(false);
    return true;
  } catch (e) {
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים');
    setLoading(false);
    return false;
  }
};
